import _LoadingMessageItem from './LoadingMessageItem';
import _SystemMessageItem from './SystemMessageItem';
import _TimeMessageItem from './TimeMessageItem';
import _UserMessageItem from './UserMessageItem';
import _UserTag from './UserTag';
import _MedicalRecordTag from './MedicalRecordTag';

export const LoadingMessageItem = _LoadingMessageItem;
export const SystemMessageItem = _SystemMessageItem;
export const TimeMessageItem = _TimeMessageItem;
export const UserMessageItem = _UserMessageItem;
export const UserTag = _UserTag;
export const MedicalRecordTag = _MedicalRecordTag;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/ChannelDetail/Message/index.js